module.exports = __webpack_public_path__ + "static/media/Franklin D. Roosevelt (I) - 1940.dbb126c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Franklin D. Roosevelt (I) - 1940.jpg
// module id = 462
// module chunks = 0